import React, { Component, lazy } from 'react';
import { ThemeProvider } from 'styled-components/macro';

import theme from 'Theme/Theme';
import themeDiabetinoCZ from 'Theme/DiabetinoCZ/Theme';
import themeDiabetinoPL from 'Theme/DiabetinoPL/Theme';
import GlobalStyle from 'Theme/GlobalStyle';
import Loader from 'components/Loader/Loader';

import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
// import Quiz from 'views/Quiz/Quiz';
import withClearCache from 'helpers/ClearCache';
import { getBuildDate } from 'helpers/utils';
// import LogRocket from 'logrocket';
import { componentLoader } from 'helpers/componentLoader';
import IE11Redirect from 'views/Quiz/IE11Redirect/IE11Redirect';
import TagManager from 'react-gtm-module';
import { getAppType } from '../../i18n.js';


const isIE = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  const trident = ua.indexOf('Trident/');
  return (msie > 0 || trident > 0);
}


i18next.init({
  interpolation: { escapeValue: false },
});

if (isIE()) {
  window.location = `microsoft-edge:${window.location}`
}


const Quiz = lazy(() => componentLoader(() => import('views/Quiz/Quiz')), 5);
const DiabetinoCZ = lazy(() => componentLoader(() => import('views/DiabetinoCZ/Quiz')), 5);
const DiabetinoPL = lazy(() => componentLoader(() => import('views/DiabetinoPL/Quiz')), 5);

class Root extends Component {
  constructor(props) {
    super(props);
    this.RootRef = React.createRef();
    this.state = { 
      rootRef: null,
      appType: getAppType()
    };
    this.lastSearch = window.location.search;
  }

  componentDidMount() {
    this.setState({ rootRef: this.RootRef.current });

    this.handleLocationChange = () => {
      const newAppType = getAppType();
      if (newAppType !== this.state.appType) {
        console.log('App type changed from', this.state.appType, 'to', newAppType);
        this.setState({ appType: newAppType });
      }
    };

    window.addEventListener('popstate', this.handleLocationChange);

    this.checkAppTypeInterval = setInterval(() => {
      const currentSearch = window.location.search;
      if (currentSearch !== this.lastSearch) {
        this.lastSearch = currentSearch;
        const newAppType = getAppType();
        if (newAppType !== this.state.appType) {
          console.log('App type changed from', this.state.appType, 'to', newAppType);
          this.setState({ appType: newAppType });
        }
      }
    }, 100);

    const GTM_KEY = process.env.REACT_APP_GTM;
    if (GTM_KEY) {
        TagManager.initialize({ gtmId: GTM_KEY });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const currentAppType = getAppType();
    if (currentAppType !== this.state.appType) {
      console.log('App type changed from', this.state.appType, 'to', currentAppType);
      this.setState({ appType: currentAppType });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handleLocationChange);
    if (this.checkAppTypeInterval) {
      clearInterval(this.checkAppTypeInterval);
    }
  }

  render() {
    const { rootRef, appType } = this.state;
    console.log('build date: ', getBuildDate());
    console.log('Current app type: ', appType);

    let AppComponent;
    let currentTheme;
    switch (appType) {
      case 'diabetino-cz':
        AppComponent = DiabetinoCZ;
        currentTheme = themeDiabetinoCZ;
        break;
      case 'diabetino-pl':
        AppComponent = DiabetinoPL;
        currentTheme = themeDiabetinoPL;
        break;
      case 'quiz':
      default:
        AppComponent = Quiz;
        currentTheme = theme;
        break;
    }

    const isLocalhost = window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1' || 
                       window.location.hostname.startsWith('127.') || 
                       window.location.hostname === '[::1]';
    
    const devModeIndicator = isLocalhost ? (
      <div style={{
        position: 'fixed',
        top: 0,
        right: 0,
        background: 'rgba(0, 0, 0, 0.8)',
        color: 'white',
        padding: '8px 12px',
        fontSize: '12px',
        zIndex: 9999,
        fontFamily: 'monospace',
        borderRadius: '0 0 0 4px'
      }}>
        <div>DEV MODE: {appType}</div>
        <div style={{ fontSize: '10px', marginTop: '4px', opacity: 0.8 }}>
          ?app=quiz | ?app=diabetino-pl | ?app=diabetino-cz | ?app=reset
        </div>
      </div>
    ) : null;

    return (
      <div ref={this.rootRef}>
        <GlobalStyle />
        <ThemeProvider theme={currentTheme}>
          <I18nextProvider i18n={i18next}>
            {devModeIndicator}
            <React.Suspense fallback={<Loader />}>
              <AppComponent key={appType} rootRef={rootRef} />
            </React.Suspense>
          </I18nextProvider>
        </ThemeProvider>
      </div>
    );
  }
}

export default withClearCache(Root);
